import React from 'react';
import PropTypes from 'prop-types';
import './ErrorDisplay.css';

const ErrorDisplay = ({ error, onRetry, className = '' }) => {
    if (!error) return null;

    const errorMessage = error.message || 'An unexpected error occurred';
    const errorDetails = error.details;

    return (
        <div className={`error-display ${className}`}>
            <div className="error-icon">⚠️</div>
            <div className="error-content">
                <h3 className="error-title">Oops! Something went wrong</h3>
                <p className="error-message">{errorMessage}</p>
                {errorDetails && (
                    <div className="error-details">
                        {typeof errorDetails === 'object' ? (
                            <ul>
                                {Object.entries(errorDetails).map(([key, value]) => (
                                    <li key={key}>
                                        <strong>{key}:</strong> {value}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>{errorDetails}</p>
                        )}
                    </div>
                )}
                {onRetry && (
                    <button 
                        className="error-retry-button"
                        onClick={onRetry}
                    >
                        Try Again
                    </button>
                )}
            </div>
        </div>
    );
};

ErrorDisplay.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string,
        details: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])
    }),
    onRetry: PropTypes.func,
    className: PropTypes.string
};

export default ErrorDisplay; 